import { initializeApp } from "firebase/app";

// Firebase setup for push and in-app notifications.
//
// Replace the placeholder values below with the dashboard's web app settings
// from the Firebase console (the same project as the HASHh Connect app):
//   Project settings > General > Your apps > (web app) > SDK setup and
//   configuration > Config
// Until they're filled in, the dashboard runs with notifications turned off.
export const firebaseConfig = {
  apiKey: "AIzaSyCt5xy7MsaFafOrIN4WQt9Y2nrKnrp5p5g",
  authDomain: "hashh-autmations.firebaseapp.com",
  databaseURL: "https://hashh-autmations.firebaseio.com",
  projectId: "hashh-autmations",
  storageBucket: "hashh-autmations.firebasestorage.app",
  messagingSenderId: "458671333642",
  appId: "1:458671333642:web:c9e67d9da157d5b9b75af3",
  measurementId: "G-Q2JJSF3YSC"
};

// The Web Push key pair's public key:
//   Project settings > Cloud Messaging > Web configuration >
//   Web Push certificates > Key pair
export const vapidKey = "BNivLrlQE-gHlrT0S9-PxmFPVzZdOQLrldVlZcETYQAycScckRkeBwf5Yv6X7I_1SmxTbzCkpnOfScoZKLJygDE";

const isPlaceholder = (value) => !value || String(value).includes("YOUR_");

export const isFirebaseConfigured =
  !isPlaceholder(vapidKey) &&
  ["apiKey", "projectId", "messagingSenderId", "appId"].every((key) => !isPlaceholder(firebaseConfig[key]));

let app = null;

// The Firebase app, created on first use; null until the config is filled in.
export const firebaseApp = () => {
  if (!isFirebaseConfigured) return null;
  if (!app) app = initializeApp(firebaseConfig);
  return app;
};
